import { useState } from 'react';
import { api } from '../../lib/api';
import { type StoryEntry, STORY_KINDS, when, btn, inputClass } from '../../lib/n4';

// Történet: mi történt a projektben — az ügynök és a rendszer bejegyzései; te is írhatsz bele.
export function StoryPanel({ projectId, story, onChange }: { projectId: number; story: StoryEntry[]; onChange: () => void }) {
  const [text, setText] = useState('');
  const add = async () => { if (!text.trim()) return; await api(`/api/n4/projects/${projectId}/story`, { method: 'POST', body: JSON.stringify({ text }) }); setText(''); onChange(); };
  return (
    <div className="h-full overflow-auto p-3 sm:p-4">
      <div className="mb-3 flex gap-2"><input className={inputClass} placeholder="bejegyzés a történetbe…" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && void add()} /><button className={`${btn} shrink-0`} onClick={() => void add()}>Hozzáad</button></div>
      {story.length === 0 && <p className="text-sm text-neutral-500">Még üres. Az ügynök minden lezárt kérésnél ír ide (n4_done), és a rendszer is: feltöltés, válasz, incidens.</p>}
      <ol className="a-timeline a-stagger">
        {story.map((s, i) => (
          <li key={s.id} className={`k-${s.kind}`} style={{ ['--i' as string]: Math.min(i, 12) }}>
            <time>{when(s.created_at)}</time><span className="a-chip">{STORY_KINDS[s.kind] ?? s.kind}</span>{s.version_id ? <span className="ver">verzió mentve</span> : null}
            <p>{s.text}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
